import { request, success, failure } from 'app/actions';
import * as actions from './controlPanelActions';

import { concat } from 'lodash';

const initialState = {
  isLoading: false,
  logs: [],
  logsNotRead: 0,
  error: null,
  showMore: true,
  hasMoreData: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.GET_LOGS):
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case actions.RESET_LOGS:
      return {
        ...state,
        logs: [],
        showMore: true,
        hasMoreData: true,
      };
    case actions.RESET_CONTROL_PANEL:
      return {
        ...initialState,
      };
    case success(actions.GET_LOGS):
      const logs = concat(state.logs, action.payload.content);
      // Se retornou menos de 5 itens, não há mais dados para carregar
      const hasMoreData = action.payload.content.length > 5;
      
      return {
        ...state,
        isLoading: false,
        logs,
        showMore: hasMoreData,
        hasMoreData,
        error: null,
      };
    case failure(actions.GET_LOGS):
      return {
        ...state,
        isLoading: false,
        showMore: false,
        hasMoreData: false,
      };
    case success(actions.GET_LOGS_READ):
      return {
        ...state,
        logsNotRead: action.payload.content.logsNotRead,
      };
    case failure(actions.GET_LOGS_READ):
      return {
        ...state,
        logsNotRead: 0,
      };
    default:
      return state;
  }
};

export default reducer;
